import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export const BreadcrumbProps = buildProps({
  isBack: {
    type: Boolean,
    default: false,
  },
} as const);

export type XBreadcrumbProps = ExtractPropTypes<typeof BreadcrumbProps>;
